export interface IAmenitiesOptions {
  id: string;
  name: string;
}

export enum AmenitiesEnum {
  ONE = "Zona BBQ",
  TWO = "Salón comunal",
  THREE = "Parque de juegos",
}
